module.exports = __webpack_public_path__ + "static/steganography-947252721a0674bce8424050d9cc1e5b.jpeg";